import { PaginatedListOfExerciseTagDto } from "@growth-machine-llc/stridist-api-client";
import { useQueryClient } from "@tanstack/react-query";
import TagsService from "../../../services/TagsService";
import {
  INVALIDATE_KEYS_ON_CLIENT_TAGS_LIST_UPDATE,
  tagOnSuccessHandler,
} from "./useCreateClientTag";
import { COACH_CLIENT_TAGS_LIST_QUERY_KEY } from "../CoachClientsTagsListScreen";
import { useOptimisticUpdateMutation } from "../../../hooks/useOptimisticUpdateMutation";
import { ALL_OPTIONS } from "../../../wrappers/router/coach/CoachClientsWrapper";
import { useContext } from "react";
import { CoachClientFiltersContext } from "../../../contexts/CoachClientFiltersContext";

const NONE_TAG_ID = -1;

export function useDeleteClientTag() {
  const queryClient = useQueryClient();
  const { filterTagIds: tagIds, setFilterTagIdsChange: handleTagIdsChange } =
    useContext(CoachClientFiltersContext) || {
      filterTagIds: [],
      setFilterTagIdsChange: () => {},
    };

  return useOptimisticUpdateMutation({
    queryKey: [COACH_CLIENT_TAGS_LIST_QUERY_KEY],
    mutationFn: TagsService.deleteTag,
    optimisticUpdater: {
      updateFn: (oldData: PaginatedListOfExerciseTagDto, id: number) => {
        return {
          ...oldData,
          totalCount: oldData.totalCount - 1,
          items: oldData.items.filter((item) => item.id !== id),
        } as PaginatedListOfExerciseTagDto;
      },
    },

    exactQueryKey: false,
    options: {
      onSuccess: (_, id) => {
        tagOnSuccessHandler(
          queryClient,
          INVALIDATE_KEYS_ON_CLIENT_TAGS_LIST_UPDATE,
        );

        if (
          tagIds !== ALL_OPTIONS &&
          Array.isArray(tagIds) &&
          tagIds.length > 0 &&
          tagIds.includes(id)
        ) {
          const newTagIds = tagIds.filter((tagId) => tagId !== id);
          handleTagIdsChange(newTagIds.length > 0 ? newTagIds : [NONE_TAG_ID]);
        }
      },
    },
  });
}
